import React, { useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import queryString from 'query-string'
import FlatPagination from 'material-ui-flat-pagination'
import axios from 'axios'
import moment from 'moment-timezone'

import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  Button,
  Typography
} from '@material-ui/core'
import Title from '../components/atoms/Title'
import { PushLogs } from '../types/Notification'

import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    width: '100%'
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    height: `100%`
  }
}))

type QueryString = {
  sort?: string
  order?: 'asc' | 'desc'
  page?: string
  limit?: string
}

const PushHistory: React.FC<RouteComponentProps<{ kaiin_no: string }>> = ({
  match,
  history,
  location
}) => {
  // ページをロードした瞬間の初期クエリストリング
  const initQuery: QueryString = queryString.parse(location.search)
  const [total, setTotal] = useState<number>(0)
  const [limit, setLimit] = useState<number>(100)
  const classes = useStyle({})
  const [pushLogs, setPushLogs] = useState<
    (PushLogs & {
      pushResults?: {
        andloid: { status: string; message: string; result: { topic: string } }
        iphone: { status: string; message: string; result: { operatedDeviceCount: number } }
      }[]
    })[]
  >([])

  const fetchPushLogs = async (params: QueryString) => {
    const { data } = await axios.get<{
      number_of_hits: number
      rows: PushLogs[]
    }>(`/notifications/push-logs`, {
      params: {
        sort: ['created_at'],
        order: ['desc'],
        page: params.page,
        limit: limit
      }
    })
    setPushLogs(
      data.rows.map((pushLog: PushLogs) => {
        return {
          ...pushLog,
          pushResults: JSON.parse(pushLog.result)
        }
      })
    )
    setTotal(data.number_of_hits)
    if (data.number_of_hits > 0) {
      setLimit(100)
    } else {
      setLimit(0)
    }
  }

  useEffect(() => {
    try {
      initQuery.page = String(1)
      fetchPushLogs(initQuery)
    } catch (error) {
      alert(error.message)
    }
  }, [])

  const scrollPageTop = () =>
    document.getElementById('main-content').scroll({
      top: 0,
      left: 0
    })

  const handlePageChange = async (page: number) => {
    try {
      const query: QueryString = {
        page: String(page)
      }
      history.push({
        pathname: '/push-history',
        search: queryString.stringify(query)
      })
      scrollPageTop()
      await fetchPushLogs(query)
    } catch (error) {
      alert(error.message)
    }
  }

  const currentPageCaption = () => {
    const totalNumber = total
    const currentPage = Number(initQuery.page) || 1
    const totalPage = Math.ceil(total / limit)
    const startNumber = totalNumber === 0 ? 0 : (currentPage - 1) * limit + 1
    const lastNumber = currentPage === totalPage ? totalNumber : currentPage * limit
    return (
      <Typography variant="caption" align="center" display="block" color="primary">
        全 {totalNumber} 件｜ ({startNumber} - {lastNumber}件)
      </Typography>
    )
  }

  const pushCount = (pushResults: { status: 'ok' | 'error' }[]): number => {
    if (Array.isArray(pushResults)) {
      return pushResults.length
    } else {
      return 0
    }
  }

  const successCount = (pushResults: { status: 'ok' | 'error' }[]): number => {
    if (Array.isArray(pushResults)) {
      return pushResults.filter(result => result.status === 'ok').length
    } else {
      return 0
    }
  }

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Box display="flex" justifyContent="space-between">
            <Title>プッシュ通知送信履歴</Title>
            <Box ml={3}>
              <Button color="primary" variant="outlined" href="/">
                一覧に戻る
              </Button>
            </Box>
          </Box>
          <Box my={4}>
            <Box display="flex" justifyContent="center">
              {currentPageCaption}
            </Box>
            <Box display="flex" justifyContent="center">
              <FlatPagination
                limit={limit}
                offset={(Number(initQuery.page || 1) - 1) * limit}
                total={total}
                onClick={(ev, offset, _page) => {
                  handlePageChange(_page)
                }}
              />
            </Box>
          </Box>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>送信日時</TableCell>
                <TableCell>送信メッセージ</TableCell>
                <TableCell>処理結果</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pushLogs.map((pushLog, index) => (
                <TableRow key={pushLog.id}>
                  <TableCell align="left">
                    <Box whiteSpace="nowrap">
                      {moment(pushLog.created_at).format('YYYY/MM/DD HH:mm:ss')}
                    </Box>
                  </TableCell>
                  <TableCell align="left">{pushLog.notification_title}</TableCell>
                  <TableCell align="left">
                    {pushLog.is_error === 1 ? (
                      <Box whiteSpace="nowrap">
                        <Typography variant="inherit" color="error">
                          送信NG
                        </Typography>
                      </Box>
                    ) : (
                      <Typography variant="inherit" color="initial">
                        送信OK
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Box my={4}>
            <Box display="flex" justifyContent="center">
              {currentPageCaption}
            </Box>
            <Box display="flex" justifyContent="center">
              <FlatPagination
                limit={limit}
                offset={(Number(initQuery.page || 1) - 1) * limit}
                total={total}
                onClick={(ev, offset, _page) => {
                  handlePageChange(_page)
                }}
              />
            </Box>
          </Box>
        </Paper>
      </Grid>
    </React.Fragment>
  )
}

export default PushHistory
